import { render, staticRenderFns } from "./InventoryListItem.vue?vue&type=template&id=3998ae70&scoped=true&"
import script from "./InventoryListItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./InventoryListItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InventoryListItem.vue?vue&type=style&index=0&id=3998ae70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3998ae70",
  null
  
)

export default component.exports